const h = {
  name: "Mexico",
  dimensions: { width: 40, height: 34 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 34" style="enable-background:new 0 0 40 34;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<path class="st0" d="M22,19h-4v-2h4V19z"/>
<path class="st0" d="M19,14h2v-2h-2V14z"/>
<path class="st0" d="M23,24h-6v-2h6V24z"/>
<path class="st0" d="M16,29h8v-2h-8V29z"/>
<path class="st0" d="M14,0h12v7h3v5h3v5h3v5h3v5h2v7H0v-7h2v-5h3v-5h3v-5h3V7h3V0z M36,24h-9.1l0.7,3H36V24z M38,32l0-3h-9.9l0.7,3
	H38z M26.7,32L21.2,9h-2.4l-5.5,23H26.7z M4,27h8.4l0.7-3H4V27z M11.2,32l0.7-3H2v3H11.2z M33,19h-7.3l0.7,3H33V19z M7,22h6.6l0.7-3
	H7V22z M30,14h-5.5l0.7,3H30V14z M10,17h4.8l0.7-3H10V17z M27,9h-3.7l0.7,3h3V9z M13,12h3l0.7-3H13V12z M24,2h-8v5h3V4h2v3h3V2z"/>
</svg>
  `
};
export {
  h as Mexico
};
